module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_68.5665c94a.jpg";